import { render, staticRenderFns } from "./applyReturnOrderrCartManage.vue?vue&type=template&id=a534e35a&scoped=true"
import script from "./applyReturnOrderrCartManage.vue?vue&type=script&lang=js"
export * from "./applyReturnOrderrCartManage.vue?vue&type=script&lang=js"
import style0 from "./applyReturnOrderrCartManage.vue?vue&type=style&index=0&id=a534e35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a534e35a",
  null
  
)

export default component.exports